export default __webpack_public_path__ + "static/media/mail.87c254e9.svg";